import { useEffect, useRef } from 'react';

export function useDismiss(open, onClose, refs) {
  const refsRef = useRef(refs);
  const onCloseRef = useRef(onClose);
  refsRef.current = refs;
  onCloseRef.current = onClose;

  useEffect(() => {
    if (!open) return undefined;

    const onPointer = (event) => {
      const inside = refsRef.current.some(
        (ref) => ref.current && ref.current.contains(event.target)
      );
      if (!inside) onCloseRef.current();
    };

    const onKey = (event) => {
      if (event.key === 'Escape') onCloseRef.current();
    };

    document.addEventListener('mousedown', onPointer);
    document.addEventListener('keydown', onKey);
    return () => {
      document.removeEventListener('mousedown', onPointer);
      document.removeEventListener('keydown', onKey);
    };
  }, [open]);
}
